import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import EventAssignModal from './components/EventAssignModal';
import { hasEventsTag } from './utils/eventsTag';
export default function addEventComposer() {
  // DiscussionComposer is code-split, same as flarum/tags' own
  // addTagComposer.js - extend() has to target it by string path so the
  // callback attaches once it's actually loaded. No canEditEvent()
  // permission check here: a brand new discussion has no author yet
  // distinct from the actor creating it, so anyone who can start a
  // discussion in this category can fill in its event info.
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const tags = this.composer.fields.tags || [];
    if (!hasEventsTag(tags)) return;
    items.add('event', m(Button, {
      icon: "fas fa-calendar-alt",
      onclick: () => app.modal.show(EventAssignModal, {
        initialEvent: this.composer.fields.event,
        onsubmit: event => {
          this.composer.fields.event = event;
        }
      })
    }, app.translator.trans('champis-events.forum.event.control_button')));
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    // data() returns a flat {title, content, ...} object passed straight to
    // Model.save() as its attributes map - no nested .attributes wrapper,
    // same level as title/content (see champis-species' own
    // addSpeciesComposer.js for the same pattern with `species`).
    if (this.composer.fields.event) {
      data.event = this.composer.fields.event;
    }
  });
}